import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { assignProps as _assignProps } from 'intergalactic/core';
import React from 'react';
import createComponent, { Root, Component, register } from 'intergalactic/core';
import getOriginChildren from 'intergalactic/utils/lib/getOriginChildren';
import isNode from 'intergalactic/utils/lib/isNode';
var Context = register.get('neighbor-location-context', /*#__PURE__*/React.createContext({}));
function childrenWithoutFragment(children) {
  return React.Children.toArray(children).reduce(function (acc, node) {
    if ( /*#__PURE__*/React.isValidElement(node) && node.type === React.Fragment) {
      acc.push.apply(acc, childrenWithoutFragment(node.props.children));
    } else {
      acc.push(node);
    }
    return acc;
  }, []);
}
function _calculateNeighborLocation(length, i) {
  // default state
  var neighborLocation = 'both';
  // if one child
  if (length === 1) {
    return undefined;
  }
  // if first child
  if (i === 0) {
    neighborLocation = 'right';
  }
  // if last child
  if (i === length - 1) {
    neighborLocation = 'left';
  }
  return neighborLocation;
}
var NeighborLocationRoot = /*#__PURE__*/function (_Component) {
  _inherits(NeighborLocationRoot, _Component);
  var _super = _createSuper(NeighborLocationRoot);
  function NeighborLocationRoot() {
    var _this;
    _classCallCheck(this, NeighborLocationRoot);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "controlsLengthRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "cacheChild", new Map());
    return _this;
  }
  _createClass(NeighborLocationRoot, [{
    key: "calculateNeighborLocation",
    value: function calculateNeighborLocation() {
      var controlsLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      // for not re-render component
      if (!this.cacheChild.has(component)) {
        var neighborLocation = _calculateNeighborLocation(controlsLength, this.cacheChild.size);
        // set cache
        this.cacheChild.set(component, neighborLocation);
      }
      // return default state
      return this.cacheChild.get(component);
    }
  }, {
    key: "getDetectProps",
    value: function getDetectProps() {
      return {
        getNeighborLocation: this.calculateNeighborLocation.bind(this, this.controlsLengthRef.current)
      };
    }
  }, {
    key: "setContext",
    value: function setContext() {
      return {
        controlsLengthRef: this.controlsLengthRef
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = this.asProps;
      var _this$asProps = this.asProps,
        Children = _this$asProps.Children,
        Tag = _this$asProps.tag,
        controlsLength = _this$asProps.controlsLength;
      this.controlsLengthRef.current = controlsLength !== null && controlsLength !== void 0 ? controlsLength : childrenWithoutFragment(getOriginChildren(Children)).filter(isNode).length;
      this.cacheChild.clear();
      if (Tag) return /*#__PURE__*/React.createElement(Tag, _assignProps({}, _ref), /*#__PURE__*/React.createElement(Children, null));
      return /*#__PURE__*/React.createElement(Children, null);
    }
  }]);
  return NeighborLocationRoot;
}(Component);
_defineProperty(NeighborLocationRoot, "displayName", 'NeighborLocation');
var Detect = /*#__PURE__*/function (_Component2) {
  _inherits(Detect, _Component2);
  var _super2 = _createSuper(Detect);
  function Detect() {
    _classCallCheck(this, Detect);
    return _super2.apply(this, arguments);
  }
  _createClass(Detect, [{
    key: "render",
    value: function render() {
      var _this$asProps2 = this.asProps,
        children = _this$asProps2.children,
        selfNeighborLocation = _this$asProps2.neighborLocation,
        getNeighborLocation = _this$asProps2.getNeighborLocation;
      var calculateNeighborLocation = getNeighborLocation ? getNeighborLocation(this) : undefined;
      var neighborLocation = selfNeighborLocation !== null && selfNeighborLocation !== void 0 ? selfNeighborLocation : calculateNeighborLocation;
      if (!children) return;
      if (typeof children === 'function') return children(neighborLocation);
      return /*#__PURE__*/React.cloneElement(React.Children.only(children), {
        neighborLocation: neighborLocation
      });
    }
  }]);
  return Detect;
}(Component);
function useNeighborLocationDetect(index) {
  var _React$useContext = React.useContext(Context),
    controlsLengthRef = _React$useContext.controlsLengthRef;
  if (controlsLengthRef.current === undefined) return false;
  return _calculateNeighborLocation(controlsLengthRef.current, index);
}
var NeighborLocation = createComponent(NeighborLocationRoot, {
  Detect: Detect
}, {
  context: Context
});
export { useNeighborLocationDetect };
export default NeighborLocation;
//# sourceMappingURL=NeighborLocation.js.map